export enum ContractStatus {
   PENDING_NON_VERIFIED = "PENDING_NON_VERIFIED",
   PENDING = "PENDING",
   OPEN = "OPEN",
   CLOSED = "CLOSED",
   DECLINED_BY_SELLER = "DECLINED_BY_SELLER",
   DECLINED_BY_BUYER = "DECLINED_BY_BUYER",
   DECLINED_VERIFICATION_TIMEOUT = "DECLINED_VERIFICATION_TIMEOUT"
}